import { render, staticRenderFns } from "./TrainerDialog.vue?vue&type=template&id=75fcfaa4&scoped=true&"
import script from "./TrainerDialog.vue?vue&type=script&lang=js&"
export * from "./TrainerDialog.vue?vue&type=script&lang=js&"
import style0 from "./TrainerDialog.vue?vue&type=style&index=0&id=75fcfaa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fcfaa4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDialog,VFlex})
